export default __webpack_public_path__ + "static/media/top-b-11-med.80c05e4d.jpg";